import { createApiClient } from "../config/ApiConfig";

const API = createApiClient(`${process.env.REACT_APP_BACKEND_URI}/api`);


export const getPriorities = async()=>{

const response = await API.get("/priorities/");

return response.data;

};